import { render, staticRenderFns } from "./LecturerSchedule.vue?vue&type=template&id=869a0246&scoped=true"
import script from "./LecturerSchedule.vue?vue&type=script&lang=js"
export * from "./LecturerSchedule.vue?vue&type=script&lang=js"
import style0 from "./LecturerSchedule.vue?vue&type=style&index=0&id=869a0246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869a0246",
  null
  
)

export default component.exports